import React, { useCallback } from 'react';

import Switch from 'components/Switch';
import {
  lessonsSelector,
  LESSON_TYPES,
  removeLiveLecture,
  setLiveLecture,
} from 'features/classCreation';
import { useDispatch, useSelector } from 'react-redux';

function DiscussionSwitch() {
  const dispatch = useDispatch();
  const lessons = useSelector(lessonsSelector);

  const handleOnChange = useCallback(
    (event) => {
      if (event.target.checked) {
        dispatch(setLiveLecture({ lesson_type: LESSON_TYPES.liveLecture }));
      } else {
        dispatch(removeLiveLecture());
      }
    },
    [dispatch]
  );

  return (
    <Switch
      checked={Boolean(lessons.live_lecture)}
      onChange={handleOnChange}
      className="m-l-xs"
      small
    />
  );
}

export default DiscussionSwitch;
